export enum COUNTRY {
  AUSTRALIA = 'Australia',
  UK = 'United Kingdom',
  USA = 'United States of America'
}
